const progressBar = () => {
    let bars = document.getElementsByClassName('progress-bar');
    if (bars.length > 0) {
        for (let bar of bars) {
            let progress = bar.querySelector('.progress-bar_value').dataset.progress;
            let background = bar.querySelector('.progress-bar_value').style.background;
            bar.querySelector('.progress-bar_value').style.cssText = 'width: ' + progress + '%; background-color: ' + background;
        }
    }
}

const collapseCompletedModule = () => {
    window.addEventListener('click', (e) => {
        let module = e.target.closest('.collapse-table');
        if (module) {
            if (module.classList.contains('collapsed')) {
                module.classList.remove('collapsed');
            } else {
                module.classList.add('collapsed');
            }
        }
    });
}

const closeSigninPopup = () => {
    // on click to .js-login-close button, if in url history previous page was in same domain - redirect to this page
    const closeLoginPage = document.querySelector('.js-login-close');
    if (closeLoginPage) {
        closeLoginPage.addEventListener('click', () => {
            // if previous page was in same domain, but not /login and not /sign-up - redirect to previous page, else redirect to home page
            if (document.referrer.includes(window.location.origin) && !document.referrer.includes('/login') && !document.referrer.includes('/sign-up')) {
                window.history.back();
            } else {
                window.location.href = window.location.origin;
            }
        });
    }
}


export {
    progressBar,
    collapseCompletedModule,
    closeSigninPopup
}
